import PropTypes from 'prop-types';
import React from 'react';

const Icon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 17 16"
  >
    <title>Information</title>
    <circle cx="8.5" cy="8" r="7.4" stroke="#94999B" strokeWidth="1.2" />
    <path
      fill="#94999B"
      d="M8.491 4h.018c.278 0 .51.096.695.288a.964.964 0 01.296.72.964.964 0 01-.296.72.927.927 0 01-.695.289H8.49a.985.985 0 01-.713-.288.995.995 0 01-.278-.72c0-.289.093-.529.278-.72A.985.985 0 018.491 4zm-.365 8.5a.4.4 0 01-.4-.4V7.271c0-.22.18-.4.4-.4h.765c.221 0 .4.18.4.4V12.1a.4.4 0 01-.4.4h-.765z"
    />
  </svg>
);

Icon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Icon.defaultProps = {
  width: 17,
  height: 16,
};

export default Icon;
